import { ElMessage } from "element-plus";
import VueCookies from "vue-cookies";

/**
 * 判断用户是否登录
 */
const checkUserLoginStatus = function () {
  return VueCookies.isKey("tokenWeb") && VueCookies.isKey("userInfo");
};
/**判断用户是否登录 未登录前往登录页面 */
const checkUserOperateAuth = (fn) => {
  return new Promise((resolve, reject) => {
    if (!checkUserLoginStatus()) {
      fn();
    } else {
      resolve();
    }
  });
};

/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
const Debounce = (fn, t) => {
  let delay = t || 500;
  let timer;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  };
};
/**错误提示 */
export const remindErrorMessage = (message) => {
  if (!sessionStorage.getItem("xm_canRemindErrorMessage")) {
    sessionStorage.setItem("xm_canRemindErrorMessage", 1);
    ElMessage({
      message: message,
      type: "warning",
    });
    setTimeout(() => {
      sessionStorage.removeItem("xm_canRemindErrorMessage");
    }, 2000);
  }
};

export { Debounce, checkUserLoginStatus, checkUserOperateAuth };
